import ghostBaffledSrc from '../../../images/svg/ghost_baffled.svg';
import ghostSrc from '../../../images/svg/ghost_chasing.svg';
import ghostFeistySrc from '../../../images/svg/ghost_feisty.svg';
import ghostHappySrc from '../../../images/svg/ghost_happy.svg';
import ghostJollySrc from '../../../images/svg/ghost_jolly.svg';
import ghostNervousSrc from '../../../images/svg/ghost_nervous.svg';
import ghostShockedSrc from '../../../images/svg/ghost_shocked.svg';
import ghostSinnisterSrc from '../../../images/svg/ghost_sinnister.svg';
import ghostStumpedSrc from '../../../images/svg/ghost_stumped.svg';

const Ghost = (
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  parentElement: HTMLElement,
  onResize: () => void
) => {
  const normal = new Image();
  normal.src = ghostSrc;
  const nervous = new Image();
  nervous.src = ghostNervousSrc;
  const shocked = new Image();
  shocked.src = ghostShockedSrc;
  const jolly = new Image();
  jolly.src = ghostJollySrc;
  const happy = new Image();
  happy.src = ghostHappySrc;
  const feisty = new Image();
  feisty.src = ghostFeistySrc;
  const baffled = new Image();
  baffled.src = ghostBaffledSrc;
  const stumped = new Image();
  stumped.src = ghostStumpedSrc;
  const sinnister = new Image();
  sinnister.src = ghostSinnisterSrc;

  const ghost_following_mouse = [normal, jolly, happy, feisty, sinnister].map((n) => {
    n.style.objectFit = 'contain';
    return n;
  });
  const ghost_touched = [shocked, baffled, stumped, nervous].map((n) => {
    n.style.objectFit = 'contain';
    return n;
  });

  console.log(ghost_following_mouse);

  let pointerPos: { x: number | undefined; y: number | undefined } = {
    x: undefined,
    y: undefined
  };
  let lastPointerPos = pointerPos;
  let ghostAni = true;
  let notMovedFor = 0;

  const ghost = {
    x: canvas.width / 2,
    y: canvas.height / 2,
    a: 0,
    id: 'boooohooo',
    width: canvas.height / 6,
    height: canvas.height / 5,
    isPointerInside: (x: number, y: number) => {
      return (
        x >= ghost.x && x <= ghost.x + ghost.width && y >= ghost.y && y <= ghost.y + ghost.height
      );
    },
    currentState: ghost_following_mouse[getRandomInt(0, ghost_following_mouse.length - 1)],
    fleeTo: {
      x: Math.random() > 0.5 ? -canvas.height / 5 : canvas.width,
      y: getRandomInt(-canvas.height / 5, canvas.height + canvas.height / 5)
    }
  };

  function lerp(start: number, end: number, amt: number) {
    return (1 - amt) * start + amt * end;
  }

  function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
  }

  const setPointerPos = (e: MouseEvent | TouchEvent) => {
    if (typeof (e as TouchEvent).touches !== 'undefined') {
      pointerPos = {
        x: (e as TouchEvent).touches[0].clientX,
        y: (e as TouchEvent).touches[0].clientY
      };
    } else {
      pointerPos = {
        x: (e as MouseEvent).clientX,
        y: (e as MouseEvent).clientY
      };
    }
  };

  const tick = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (lastPointerPos === pointerPos) {
      notMovedFor++;
    } else {
      notMovedFor = 0;
    }

    if (notMovedFor > 500 && ghost.a < 1) {
      if (ghostAni) {
        ghost.currentState =
          ghost_following_mouse[getRandomInt(0, ghost_following_mouse.length - 1)];
        ghost.width = canvas.height / 6;
        ghost.height = canvas.height / 5;
      }
      ghostAni = false;
      notMovedFor = 0;
      ghost.fleeTo = {
        x: Math.random() > 0.5 ? -canvas.height / 5 : canvas.width,
        y: getRandomInt(-canvas.height / 5, canvas.height + canvas.height / 5)
      };
    }

    if (
      !ghostAni &&
      pointerPos.x &&
      pointerPos.y &&
      ghost.isPointerInside(pointerPos.x, pointerPos.y)
    ) {
      ghost.width = canvas.height / 8;
      ghost.height = canvas.height / 6;
      ghostAni = true;
      ghost.currentState = ghost_touched[getRandomInt(0, ghost_touched.length - 1)];
      notMovedFor = 0;
    } else {
      if (ghostAni) {
        // Ghost fleeing
        if (ghost.y < canvas.height) {
          ghost.x = lerp(ghost.x, ghost.fleeTo.y, 0.008);
          ghost.y = lerp(ghost.y, ghost.fleeTo.x, 0.008);
          ghost.a = lerp(ghost.a, 0, 0.05);
        } else {
          // Ghost escaped
          ghost.currentState =
            ghost_following_mouse[getRandomInt(0, ghost_following_mouse.length - 1)];
          ghost.width = canvas.height / 6;
          ghost.height = canvas.height / 5;
        }
      } else {
        // Ghost approaching cursor
        ghost.a = lerp(ghost.a, 0.8, 0.005);
        ghost.x = lerp(ghost.x, (pointerPos.x ?? canvas.width / 2) - ghost.width / 2, 0.004);
        ghost.y = lerp(ghost.y, (pointerPos.y ?? canvas.height / 2) - ghost.height / 2, 0.004);
      }
    }
    ctx.drawImage(ghost.currentState, ghost.x, ghost.y, ghost.width, ghost.height);
    ctx.globalAlpha = ghost.a;
    lastPointerPos = pointerPos;
    requestAnimationFrame(tick);
  };
  tick();

  window.addEventListener('resize', () => {
    onResize();
  });

  window.addEventListener('mousemove', setPointerPos);

  window.addEventListener('touchmove', setPointerPos);
  //window.addEventListener('touchend', unsetPointerPos);
};
export default Ghost;
